import {TenantApplication} from "../tenant/TenantApplication";
import {TimePeriod} from "../TimePeriod";

export class ErrorFilter {
    //errorTypes: ErrorType[];
    occurredTimeRange: TimePeriod;
    //isSolved?: boolean;
    applications: TenantApplication[];

    constructor(applications: TenantApplication[], occurredTimeRange: TimePeriod) {
        this.occurredTimeRange = occurredTimeRange;
        this.applications = applications;
    }
}
